export default __webpack_public_path__ + "static/blob-45-84add80fcea3af00f02a63e8ef6c8195.svg";